module.exports = __webpack_public_path__ + "assets/img/micronet-member-hover_2.20634035.png";